import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'
import { FIELD_BADGE_LABELS } from '@/core/hooks/useCardNavigation/utils/getFieldBadgeLabel'
import type { FieldExecutionParams } from '@/core/types/library.type'

export const getFieldReadLabel = (field: FieldExecutionParams['field']): string => {
  if (field.type === UnifiedGraftModelTypeKey.GLOBAL_FIELD) {
    return FIELD_BADGE_LABELS.GLOBAL
  }

  if (field.type === UnifiedGraftModelTypeKey.STATIC_FIELD || field.isStatic) {
    return FIELD_BADGE_LABELS.STATIC
  }

  return FIELD_BADGE_LABELS.INSTANCE
}
